import create from 'zustand';
import { GetBalancesParams } from '@ar/network/AccountsReceivable.network';

export type SearchParams = Partial<Omit<GetBalancesParams, 'supplier_id'>>;

type CustomersStoreState = {
    searchParams: Omit<GetBalancesParams, 'supplier_id'>,
};

type CustomersStoreActions = {
    updateSearchParams: (params: SearchParams) => void,
    clearFilter: (filter: keyof SearchParams) => void,
    reset: () => void,
};

type CustomersStore = CustomersStoreState & CustomersStoreActions;

const CUSTOMERS_STORE_INITIAL_STATE: CustomersStoreState = {
    searchParams: {
        has_auto_collection: undefined,
        has_payment_method: undefined,
        limit: 20,
        offset: 0,
        sort_by: undefined,
        customer_id: undefined,
        name: undefined,
        is_active: true,
    },
};

export const useCustomersStore = create<CustomersStore>(
    (set): CustomersStore => ({
        ...CUSTOMERS_STORE_INITIAL_STATE,

        updateSearchParams: (params: SearchParams) => set(
            (state) => ({
                searchParams: {
                    ...state.searchParams,
                    ...params,
                },
            }),
        ),

        clearFilter: (filterKey: keyof SearchParams) => set(
            (state) => ({
                searchParams: {
                    ...state.searchParams,
                    [filterKey]: CUSTOMERS_STORE_INITIAL_STATE.searchParams[filterKey],
                },
            }),
        ),

        reset: () => set(CUSTOMERS_STORE_INITIAL_STATE),
    }),
);
